
import {
  FETCH_LOGIN_REQUEST,
  FETCH_LOGIN_SUCCESS,
  FETCH_LOGIN_FAIL,
  FETCH_EDIT_REQUEST,
  FETCH_EDIT_SUCCESS,
  FETCH_EDIT_FAIL,
  FETCH_LANGUAGE_REQUEST,
  FETCH_LANGUAGE_SUCCESS,
  FETCH_LANGUAGE_FAIL,
  FETCH_LOGOUT_REQUEST,
  REINTIALIZE,
} from "./type";
import axios from 'axios';
import { API_ENDPOINT, MyTicket_PATH, MyTicket_USER,MyTicket_RULES, MyTicket_TOKEN, MyTicket_TYPE, MyTicket_LANGUAGE,
  MyTicket_USER_Cinema, MyTicket_TOKEN_Cinema, MyTicket_TYPE_Cinema, MyTicket_LANGUAGE_Cinema,
  MyTicket_USER_Event, MyTicket_TOKEN_Event, MyTicket_TYPE_Event, MyTicket_LANGUAGE_Event
} from '../../AppConfig';
import { showSnack } from 'react-redux-snackbar';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import String from "../../Assets/Localization/local"
import cookie from 'react-cookies'


export function loginRequest(data, Lang,url) {
  String.setLanguage(Lang)
  let URL=url

  return (dispatch, getState) => {
    dispatch({ type: FETCH_LOGIN_REQUEST });
    dispatch(showLoading());
    console.log("Response take place ",data)
    if (data.email && data.password && data.type) {
      axios.post(`${API_ENDPOINT}/${URL}`, data,
        {
          headers: {
            "Accept-Language": Lang,
            "Content-Type": "application/json"
          }
        }
      ).then(response => {
        // console.log("Response  ",response,`${API_ENDPOINT}/${URL}`)
        let userObject = []
        if(response.data.user.type==="ADMIN"){
           userObject = [
            { key: MyTicket_USER, value: response.data.user },
            { key: MyTicket_TOKEN, value: response.data.token },
            { key: MyTicket_TYPE, value: response.data.user.type },
            { key: MyTicket_RULES, value: response.data.user.rules },
            { key: MyTicket_LANGUAGE, value: response.data.user.language },
          ]
          sessionStorage.setItem("TicketUser", "ADMIN")
        }else if(response.data.user.categoryType==="CINEMA"){
          userObject = [
            { key: MyTicket_USER_Cinema, value: response.data.user },
            { key: MyTicket_TOKEN_Cinema, value: response.data.token },
            { key: MyTicket_TYPE_Cinema, value: response.data.user.type },
            // { key: MyTicket_RULES, value: response.data.user.rules },
            { key: MyTicket_LANGUAGE_Cinema, value: response.data.user.language },
          ]
          sessionStorage.setItem("TicketUser", "CINEMA")
        }else{
          userObject = [
            { key: MyTicket_USER_Event, value: response.data.user },
            { key: MyTicket_TOKEN_Event, value: response.data.token },
            { key: MyTicket_TYPE_Event, value: response.data.user.type },
            // { key: MyTicket_RULES, value: response.data.user.rules },
            { key: MyTicket_LANGUAGE_Event, value: response.data.user.language },
          ]
          sessionStorage.setItem("TicketUser", "EVENT")
        }
        console.log("Response  ",userObject,response)
        saveToCookies(userObject)
       

        dispatch(hideLoading());
        dispatch({ payload: response.data, type: FETCH_LOGIN_SUCCESS });

     
        // SaveRoles(response.data.user.id, response.data.token)
      })
        .catch(err => {
          console.log("error take place ",err.response)
          dispatch(hideLoading());
          dispatch({ type: FETCH_LOGIN_FAIL });
          if (!err.response) {
            dispatch(showSnack('myUniqueId', {
              label: String.networkError,
              timeout: 5000,
              button: { label: String.loginKey }
            }));

          }
          else if (err.response.status === 404 || err.response.status === 422) {
            dispatch(hideLoading());
            dispatch(showSnack('myUniqueId', {
              label: String.loginError,
              timeout: 5000,
              button: { label: String.loginKey }
            }));
          }
          else if (err.response.status === 403) {
            dispatch(hideLoading());
            dispatch(showSnack('myUniqueId', {
              label: String.userError,
              timeout: 5000,
              button: { label: String.loginKey }
            }));


          }
          else if (err.response.status === 401) {
            dispatch(hideLoading());
          }
        })

    }
  }
}
export function updateProfile(data, id, token, Lang) {
  String.setLanguage(Lang)

  return (dispatch, getState) => {
    dispatch({ type: FETCH_EDIT_REQUEST });
    dispatch(showLoading());
    axios.put(`${API_ENDPOINT}/admin/updateProfile`, data,
      {
        headers: {
          "Accept-Language": Lang,
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    ).then(response => {
      console.log("response",response)
      let userObject = [
        { key: MyTicket_USER, value: response.data },
        // { key: MyTicket_TOKEN, value: response.data.token },
        { key: MyTicket_TYPE, value: response.data.type },
        { key: MyTicket_LANGUAGE, value: response.data.language },
      ]
      saveToCookies(userObject)
      dispatch({ payload: response.data, type: FETCH_EDIT_SUCCESS });
      dispatch(hideLoading());
      dispatch(showSnack('myUniqueId', {
        label: String.EditReqDone,
        timeout: 5000,
      }));
    })
      .catch(err => {
        console.log("error take place",err.response)
        dispatch({ type: FETCH_EDIT_FAIL });
        if (!err.response) {
          dispatch(hideLoading());
          dispatch(showSnack('myUniqueId', {
            label: String.networkError,
            timeout: 5000,
            button: { label: String.loginKey }
          }));

        }
        else if (err.response.status === 404 || err.response.status === 422) {
          dispatch(hideLoading());
          dispatch(showSnack('myUniqueId', {
            label: String.loginError,
            timeout: 5000,
            button: { label: String.loginKey }
          }));
        }
        else if (err.response.status === 403) {
          dispatch(hideLoading());
          dispatch(showSnack('myUniqueId', {
            label: err.response.data.errors,
            timeout: 5000,
            button: { label: String.loginKey }
          }));


        }
        else if (err.response.status === 401) {
          dispatch(hideLoading());
        }
      })

  }

}
export function sendLogout() {
  let userObject = [
    { key: MyTicket_USER, value: null },
    { key: MyTicket_TOKEN, value: null },
    { key: MyTicket_USER_Cinema, value: null },
    { key: MyTicket_TOKEN_Cinema, value: null },
    { key: MyTicket_USER_Event, value: null },
    { key: MyTicket_TOKEN_Event, value: null },
  ]
  saveToCookies(userObject)
  return (dispatch, getState) => {
    dispatch({ type: FETCH_LOGOUT_REQUEST });
  }
}

export function langauge(lang, token, Submitdata) {
  const Data = new FormData();

  Data.append('language', lang)
  let userObject = [
    { key: MyTicket_LANGUAGE, value: lang },
  ]
  saveToCookies(userObject)
  return (dispatch, getState) => {
    dispatch({ type: FETCH_LANGUAGE_SUCCESS, payload: lang });
    dispatch({ type: FETCH_LANGUAGE_REQUEST });
    dispatch(showLoading());
    let uri = `${API_ENDPOINT}/admin/updateProfile`;
    axios.put(uri, Data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(response => {
        dispatch({ type: FETCH_LANGUAGE_SUCCESS, payload: lang });
        dispatch(hideLoading());
      }).catch(error => {
        dispatch({ type: FETCH_LANGUAGE_FAIL });
        dispatch(hideLoading());
      })
  }

}

export function IntializeToken(token, lang, user) {
  return (dispatch, getState) => {
    dispatch({ type: REINTIALIZE, payload: { token: JSON.parse(token), user: JSON.parse(user), lang: lang } });
  }
}

export function saveToCookies(object) {
  for (let i = 0; i < object.length; i++) {
    cookie.save(object[i].key, JSON.stringify(object[i].value), { path: MyTicket_PATH });
  }
}